import React from "react";
import {
  ArrayInput,
  AutocompleteInput,
  BooleanInput,
  DateInput,
  Edit,
  FormDataConsumer,
  FunctionField,
  Labeled,
  ReferenceInput,
  ReferenceManyField,
  SaveButton,
  SelectInput,
  SimpleFormIterator,
  TabbedForm,
  TextField,
  TextInput,
  Toolbar,
  useCreate,
  useDataProvider,
  useGetIdentity,
  useGetList,
  useNotify,
  usePermissions,
  useRecordContext,
  useRefresh,
  useUpdate
} from "react-admin";
import { useNavigate } from "react-router-dom";
import { Button, Box, Chip, Typography, Dialog, DialogTitle, DialogContent, DialogActions, FormControlLabel, Checkbox, TextField as MuiTextField, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import makeStyles from '@mui/styles/makeStyles';
import StoreMap from './StoreMap'
import WidthContextProvider, { WidthContext } from "custom_components/WidthProvider";
import AdminMasterStoreTab from 'custom_components/AdminMasterStoreTab'
import { NotesIterator } from 'custom_components/notes';
import { useClientContext } from 'contexts/client';
import GetInvitations from './components/GetInvitations';
import GetInvitationHistory from './components/GetInvitationHistory';


const useStyles = makeStyles({
  inlineBlock: { display: "inline-flex", marginRight: "1rem" },
  rightFloat: { display: "inline-flex", float: "right" },
});

export const titleCase = (string) => {
  return string[0].toUpperCase() + string.substr(1).toLowerCase();
};

const InfoBateField = (props) => {
  const classes = useStyles();
  return <TextField formClassName={classes.infobate_attr} {...props} />;
};
InfoBateField.defaultProps = {
  addLabel: true,
};

/* const rowStyle = (record, index, defaultStyle = {}) => {
  let style = defaultStyle;
  if (record) {
    if (record.onpoint_chain_mapping_type === "IB")
      return {
        ...style,
        borderLeftColor: green[500],
        borderLeftWidth: 5,
        borderLeftStyle: "solid",
      };
    if (
      record.onpoint_chain_mapping_type === "RMA" ||
      record.onpoint_chain_mapping_type === "RMA"
    )
      return {
        ...style,
        borderLeftColor: orange[500],
        borderLeftWidth: 5,
        borderLeftStyle: "solid",
      };
    if (record.onpoint_chain_mapping_type === "HARDCODED")
      return {
        ...style,
        borderLeftColor: red[500],
        borderLeftWidth: 5,
        borderLeftStyle: "solid",
      };
  }

  return style;
}; */

const categorySort = { field: "dislayval", order: "ASC" };
const chainSort = { field: "primary_name", order: "ASC" };

const styles = {
  constainer: {
    display: "flex",
    padding: "1em",
  },
  constainer2: {
    display: "flex",
    flex: 2,
  },
  marginRight: { marginRight: "1em" },
  marginLeft: { marginLeft: "1em" },
  minWidth: { minWidth: 300 },
};

export function NewStatusNote(
    foreignKeyMapping,
    record,
    submitAutonote,
    newStatus,
    identity,
    create
){
    const note_resource = 'onpoint_master_customer_notes'  // CURRENTLY FOR ONPOINT ONLY!!!
    const log_resource = 'onpoint_store_status_log'

    let text = "";

    if (!record || !identity) return null;
    if (!submitAutonote) return null;

    const statusMap = new Map(storeStatusList.map(obj => [obj.id, obj.name]));
    statusMap.set(null, 'No status')
    statusMap.set(undefined, 'No status')

        const data = {
            [foreignKeyMapping]: record.id,
            text,
        };

        data.text = "Store status changed from " + statusMap.get(record.store_status) + " to " + statusMap.get(newStatus)

        create(note_resource, {data:data}, {
            onSuccess: () => {
                text = "";
            },
        });


        const log_data = {
            [foreignKeyMapping]: record.id,
            new_status: newStatus,
            old_status: record.store_status
        }
        

        create(log_resource, {data:log_data}, {
            onSuccess: () => {
                text = "";
            },
            onError: (e) =>{
                console.log(log_data)
                console.log(e)
            }
        });
        return false;
    };

const InviteButton = () => {
  const record = useRecordContext();
  const { identity, /* loading: identityLoading */ } = useGetIdentity();

  const notify = useNotify();
  const refresh = useRefresh();
  const dataProvider = useDataProvider();
  const { state: clientState } = useClientContext();
  const { total: existingInviteCount } = useGetList(
    'onpoint_extraction_software_invitation',
    { filter: { master_customer_id: record?.id }, pagination: { page: 1, perPage: 1 } },
    { enabled: !!record?.id }
  );

  const [loading, setLoading] = React.useState(false);
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const [emailToggles, setEmailToggles] = React.useState({});
  const [primaryRecipient, setPrimaryRecipient] = React.useState(null);
  const [newEmailInput, setNewEmailInput] = React.useState('');
  const [newEmailError, setNewEmailError] = React.useState(false);

  const handleClick = React.useCallback(() => {
    // initialize toggles from record defaults
    const initialToggles = {};
    if (record?.email) {
      initialToggles[record.email] = true;
    }
    if (record?.wam_rep_email) {
      initialToggles[record.wam_rep_email] = true;
    }
    (record?.extra_invitation_email_ccs || []).forEach(cc => {
      if (cc.email) {
        initialToggles[cc.email] = true;
      }
    });
    setEmailToggles(initialToggles);
    setPrimaryRecipient(record?.email || null);
    setNewEmailInput('');
    setDialogOpen(true);
  }, [record]);

  const handleConfirm = React.useCallback(async () => {
    setDialogOpen(false);
    setLoading(true);

    const originalEmails = new Set([record?.email, record?.wam_rep_email, ...(record?.extra_invitation_email_ccs || []).map(cc => cc.email)].filter(Boolean));
    const newEmails = Object.keys(emailToggles).filter(e => !originalEmails.has(e));

    const recordUpdates = {};
    if (newEmails.length > 0) {
      const existingCCs = record?.extra_invitation_email_ccs || [];
      recordUpdates.extra_invitation_email_ccs = [
        ...existingCCs,
        ...newEmails.map(email => ({ email }))
      ];
    }
    if (primaryRecipient && primaryRecipient !== record?.email) {
      recordUpdates.email = primaryRecipient;
    }

    try {
      if (Object.keys(recordUpdates).length > 0) {
        await dataProvider.update(
          `${clientState.client.resourcePrefix}_master_customers`,
          { id: record.id, data: recordUpdates, previousData: record }
        );
        notify('Record updated');
      }

      const invite = {
        master_customer_id: record?.id,
        invitation_email_send_to: primaryRecipient || record?.email,
        added_by: parseInt(identity?.id),
        email_list: emailToggles,
      };

      await dataProvider.create("onpoint_extraction_software_invitation", {data: invite});
      notify('Invitation Sent');

      const noteData = {
        master_customer_id: record.id,
        text: "Invitation sent"
      };
      await dataProvider.create('onpoint_master_customer_notes', {data: noteData});
      notify('Note added successfully');

      refresh();
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  }, [dataProvider, identity?.id, record, refresh, notify, emailToggles, primaryRecipient, clientState]);

  const handleToggle = (email) => {
    const turningOff = !!emailToggles[email];
    setEmailToggles(prev => ({ ...prev, [email]: !prev[email] }));
    if (email === mainEmail) {
      if (turningOff) {
        setPrimaryRecipient(null);
      } else {
        setPrimaryRecipient(mainEmail);
      }
    }
  };

  const handleAddEmail = () => {
    const trimmed = newEmailInput.trim();
    if (!trimmed) return;
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed)) {
      setNewEmailError(true);
      return;
    }
    setNewEmailError(false);
    setEmailToggles(prev => ({ ...prev, [trimmed]: true }));
    if (!primaryRecipient) setPrimaryRecipient(trimmed);
    setNewEmailInput('');
  };

  const handleRemoveEmail = (email) => {
    setEmailToggles(prev => {
      const next = { ...prev };
      delete next[email];
      return next;
    });
  };

  const mainEmail = record?.email;
  const wamRepEmail = record?.wam_rep_email;
  const ccEmails = (record?.extra_invitation_email_ccs || []).filter(cc => cc.email);
  const recordEmailSet = new Set([mainEmail, wamRepEmail, ...ccEmails.map(cc => cc.email)].filter(Boolean));
  const extraEmails = Object.keys(emailToggles).filter(e => !recordEmailSet.has(e));
  const showPrimarySelect = mainEmail && !emailToggles[mainEmail];

  return (
    <>
      <Button
        size="large"
        color="secondary"
        onClick={handleClick}
        variant="contained"
        disabled={loading || !record?.email || existingInviteCount > 0}
      >
        Invite
      </Button>

      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Select Emails to Send</DialogTitle>
        <DialogContent>
          <Box display="flex" flexDirection="column" gap={1} mt={1}>
            {mainEmail && (
              <FormControlLabel
                control={
                  <Checkbox
                    checked={!!emailToggles[mainEmail]}
                    onChange={() => handleToggle(mainEmail)}
                  />
                }
                label={`Invite Email to: ${mainEmail}`}
              />
            )}
            {wamRepEmail && (
              <FormControlLabel
                control={
                  <Checkbox
                    checked={!!emailToggles[wamRepEmail]}
                    onChange={() => handleToggle(wamRepEmail)}
                  />
                }
                label={`Survey Rep: ${wamRepEmail}`}
              />
            )}
            {showPrimarySelect && !primaryRecipient && (
              <Typography variant="body2" color="warning.main" sx={{ pl: 1 }}>
                Primary recipient deselected — select a CC as primary or add a new email below.
              </Typography>
            )}
            {ccEmails.map(cc => (
              <Box key={cc.email} display="flex" alignItems="center">
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={!!emailToggles[cc.email]}
                      onChange={() => handleToggle(cc.email)}
                    />
                  }
                  label={`CC: ${cc.email}`}
                  sx={{ flex: 1, mr: 0 }}
                />
                {showPrimarySelect && primaryRecipient === cc.email && (
                  <Typography variant="caption" color="text.secondary" sx={{ pr: '4px', whiteSpace: 'nowrap' }}>
                    Primary Recipient
                  </Typography>
                )}
                {showPrimarySelect && primaryRecipient !== cc.email && (
                  <Button
                    size="small"
                    variant="text"
                    onClick={() => {
                      setPrimaryRecipient(cc.email);
                      setEmailToggles(prev => ({ ...prev, [cc.email]: true }));
                    }}
                    sx={{ whiteSpace: 'nowrap', fontSize: '0.7rem' }}
                  >
                    Set as Primary
                  </Button>
                )}
              </Box>
            ))}
            {extraEmails.map(email => (
              <Box key={email} display="flex" alignItems="center">
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={!!emailToggles[email]}
                      onChange={() => handleToggle(email)}
                    />
                  }
                  label={`Additional: ${email}`}
                  sx={{ flex: 1, mr: 0 }}
                />
                {showPrimarySelect && primaryRecipient === email && (
                  <Typography variant="caption" color="text.secondary" sx={{ pr: '4px', whiteSpace: 'nowrap' }}>
                    Primary Recipient
                  </Typography>
                )}
                <IconButton size="small" onClick={() => handleRemoveEmail(email)} aria-label="remove email">
                  <CloseIcon fontSize="small" />
                </IconButton>
              </Box>
            ))}
            <Box display="flex" gap={1} mt={1} alignItems="center">
              <MuiTextField
                size="small"
                label="Add email"
                value={newEmailInput}
                onChange={e => { setNewEmailInput(e.target.value); setNewEmailError(false); }}
                onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); handleAddEmail(); } }}
                error={newEmailError}
                helperText={newEmailError ? 'Enter a valid email address' : ''}
                sx={{ flex: 1 }}
              />
              <Button variant="outlined" onClick={handleAddEmail} disabled={!newEmailInput.trim()}>
                Add
              </Button>
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogOpen(false)}>Cancel</Button>
          <Button onClick={handleConfirm} variant="contained" color="secondary" disabled={!primaryRecipient}>
            Send Invitation
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};


const MasterChainToolbar = (props) => {

  const { client } = props.client
  const record = useRecordContext();
  const [create] = useCreate();
  const refresh = useRefresh();
  const notify = useNotify();
  const { identity } = useGetIdentity();
  const [update] = useUpdate();
  const permissions = usePermissions().data;

  return (
    <Toolbar
      {...props}
      style={{
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      <div
        style={{ display: "flex", justifyContent: "space-between", width: 220 }}
      >

        <FormDataConsumer {...props}>
          {({ formData, ...rest }) => {
            if (formData.email !== null && formData.email !== "" && !formData.patron_points_invite) {
              return <InviteButton record={formData} />;
            }
            return null;
          }}
        </FormDataConsumer>
        <FormDataConsumer {...props}>
          {({ formData, ...rest }) => {
            return <SaveButton
                redirect={"edit"}
                saving={props.saving}

                disabled={
                  !(typeof permissions === 'string' && permissions.endsWith('_admin'))
                }
                onClick={(e) => {
                    e.preventDefault();
                    NewStatusNote(
                      "master_customer_id",
                      record,
                      formData.store_status !== record.store_status,
                      formData.store_status,
                      identity,
                      create
                    );
                    if (formData.store_status !== record.store_status) {
                      notify("Store Status Log created, note created")
                    }
                    update(
                        `${client.resourcePrefix}_master_customers`,
                        {id:record.id, data: formData},
                        { onSuccess: () => { 
                            notify("Element Updated");
                            refresh(); 
                          },
                          onError: (e) => {
                            console.log(e)
                          }
                        }
                    );
                  }
                }
              />;
          }}
        </FormDataConsumer>
      </div>

      {/* {(typeof permissions === 'string' && permissions.endsWith('_admin')) && (
        <DeleteButton label="Delete" redirect="list" submitOnEnter={true} />
      )} */}
    </Toolbar>
  );
};

const StatesField = () => {
  const record = useRecordContext();
  return (
    <Box>
      {record.infobate_customer_states
        ? record.infobate_customer_states.map((item) => (
          <Chip key={item} label={item}></Chip>
        ))
        : null}
    </Box>
  )
};
StatesField.defaultProps = {
  addLabel: true,
};

const PatronPointsStoreLink = () => {
  const record = useRecordContext();
  const navigate = useNavigate();
  const { data, isLoading } = useGetList('onpoint_patron_points_stores', {
    filter: { infobate_master_customer_id: record?.id },
    pagination: { page: 1, perPage: 1 },
  });

  if (isLoading || !data || data.length === 0) return null;

  return (
    <Box sx={{ mt: 1, textAlign: 'center' }}>
      <Button
        variant="outlined"
        onClick={() => navigate(`/onpoint_patron_points_stores/${data[0].id}`)}
      >
        Patron Points Store<br />id: {data[0].id}
      </Button>
    </Box>
  );
};

const Aside = () => {
  const record = useRecordContext();
  return (
    <div style={{ width: 200, margin: '1em' }}>
      <PatronPointsStoreLink />
      <Typography variant="h6" sx={{ mt: 1 }}>Notes</Typography>
      <ReferenceManyField
        record={record}
        target="master_customer_id"
        reference="onpoint_master_customer_notes"
        sort={{ field: "date_added", order: "DESC" }}
      >
        <NotesIterator showStatus reference="onpoint_master_customer" foreignKeyMapping={'master_customer_id'} record={record} />
      </ReferenceManyField>

    </div>
  )
};

const posSystems = [
  { name: 'Verifone Commander', id: 'verifone_commander' },
  { name: 'Gilbarco Passport', id: 'gilbarco_passport' },
  { name: "NCR Radiant", id: 'ncr_radiant' },
  { name: 'SmartDesq', id: 'smartdesq' },
  { name: 'NRS', id: 'nrs' },
  { name: 'Clover', id: 'clover' },
  { name: 'FasTrax', id: 'fastrax' }
]

export const storeStatusList = [
  { id: 'incompatible_pos', name: 'Incompatible POS' },
  { id: 'e-targeted', name: 'OnPoint Engaging - Targeted' },
  { id: 'e-incomplete', name: 'OnPoint Engaging - Incomplete' },
  { id: 'escalated', name: 'Refer to Distributor / Escalated' },
  { id: 'on_hold', name: 'On Hold' },
  { id: 'technincal_error', name: 'Store Technical Error' },
  { id: 'w-withdrawn', name: 'Withdrawn - Withdrawn' },
  { id: 'w-closed_lost', name: 'Withdrawn - Closed / Lost' },
  { id: 'a-legacy', name: 'Active - Legacy' },
  { id: 'a-tc', name: 'Active - Transaction Collector' },
  { id: 'a-conversion', name: 'Active - Conversion' },
  { id: 'a-nrs', name: 'Active - NRS' },
]

const StoreForm = (props) => {
  const classes = useStyles();
  const record = useRecordContext();
  const { permissions } = usePermissions()
  const { state: client } = useClientContext()

  return (
    <TabbedForm toolbar={<MasterChainToolbar permissions={permissions} client={client}/>}>
      <TabbedForm.Tab label="Info">
        {/* <Box flex={2} mr="1em"> */}
        <Typography variant="h6" gutterBottom>
          Store Attributes
        </Typography>

        <TextInput
          label="Customer Name"
          source="infobate_customer_name"
          resource="onpoint_master_customers"
          fullWidth
          disabled
        />
        <TextInput
          label="Customer Address"
          resource="onpoint_master_customers"
          source="infobate_customer_address_1"
          multiline
          fullWidth
          disabled
        />

        <Box display="flex" gap={2} >
        <TextInput
          label="City"
          source="infobate_customer_city"
          resource="onpoint_master_customers"
          disabled
        />
        <TextInput
          label="State"
          source="infobate_customer_state"
          resource="onpoint_master_customers"
          disabled
        />
        <TextInput
          label="ZIP"
          source="infobate_customer_zip"
          resource="onpoint_master_customers"
          disabled
        />
        </Box>


        <TextInput
          flex="2"
          style={styles.marginRight}
          source="infobate_primary_chain"
          resource="onpoint_master_customers"
          fullWidth
          disabled
        />
        <ReferenceInput
          flex="1"
          label={`Customer Category`}
          source="infobate_customer_category_id"
          reference="master_customer_categories"
          sort={categorySort}
          fullWidth
          filterToQuery={(searchText) => ({ dislayval: searchText })}
          perPage={100}
          disabled
        >
          <SelectInput optionText="dislayval" fullWidth />
        </ReferenceInput>
        
        <SelectInput source="store_status" choices={storeStatusList} resettable  sx={{ minWidth: "18ch", maxWidth: "100%" }}/>

        <Typography variant="h6" gutterBottom>
          Editable Attributes
        </Typography>
        <TextInput source='teamviewer_id' />

        {/* <Box style={styles.constainer2}> */}
        <ReferenceInput
          label='OnPoint Chain'
          source='onpoint_chain_id'
          reference='onpoint_master_chain'
          sort={chainSort}
          fullWidth
          allowEmpty
          perPage={100}
          disabled={
            !(typeof permissions === 'string' && permissions.endsWith('_admin'))
          }
        >
            <AutocompleteInput
              optionText='primary_name'
              filterToQuery={searchText => ({ 'primary_name@ilike':  `${encodeURIComponent(searchText)}` })}
            />
        </ReferenceInput>
      </TabbedForm.Tab>

      <TabbedForm.Tab label="Match Store">
        <TextInput
          label="InfoBate Customer Name"
          source="infobate_customer_name"
          resource="onpoint_master_customers"
          fullWidth
          disabled
        />
        <TextInput
          label="InfoBate Customer Address"
          resource="onpoint_master_customers"
          source="infobate_customer_address_1"
          multiline
          fullWidth
          disabled
        />

        <Box display="flex" gap={2} >
          <TextInput
            label="InfoBate City"
            source="infobate_customer_city"
            resource="onpoint_master_customers"
            disabled
          />
          <TextInput
            label="InfoBate State"
            source="infobate_customer_state"
            resource="onpoint_master_customers"
            disabled
          />
          <TextInput
            label="InfoBate Zip"
            source="infobate_customer_zip"
            resource="onpoint_master_customers"
            disabled
          />

        </Box>

        <WidthContextProvider>
          <WidthContext.Consumer>
            {(width) => {
              return (record?.id) && <StoreMap {...record} width={width} />
            }}
          </WidthContext.Consumer>
        </WidthContextProvider>
      </TabbedForm.Tab>

      <TabbedForm.Tab label="Invites">
        <Typography variant="h6" gutterBottom>
          Survey Results
        </Typography>

        <TextInput label="Invite Email to" source="email" sx={{ width: '50%' }} />

        <Box display="flex" gap={2} mb={0}>
          <TextInput
            label="First Name"
            source="first_name"
            formClassName={classes.inlineBlock}
          />
          <TextInput label="Last Name" source="last_name"/>
        </Box>

        <Box display="flex" gap={2} alignItems="center">
          <TextInput label="Survey Point of Sale System" source="point_of_sale_system" disabled sx={{ mt: '4px' }}/>
          <SelectInput
            label="Secondary Point of Sale System"
            source="secondary_pos"
            choices={posSystems}
            onCreate={() => {
              const newPosSystemName = prompt('Enter a new POS system');
              const newPos = { id: newPosSystemName?.toLowerCase(), name: newPosSystemName };
              posSystems.push(newPos);
              return newPos;
            }}
            style = {{width: 300}}
            resettable
          />
        </Box>


        <TextInput label="Survey Rep User Name" source="submitted_by_user" sx={{ width: '50%' }} disabled />
        <TextInput label="Survey Rep Phone Number" source="main_contact_phone_number" sx={{ width: '50%' }} disabled />
        <TextInput label="Survey Rep Email" source="wam_rep_email" sx={{ width: '50%' }} disabled />

        <ReferenceInput
          label="Invitation Warehouse"
          source="onpoint_survey_warehouse_id"
          reference="onpoint_warehouses"
          sort={{ field: "warehouse_name", order: "ASC" }}
          allowEmpty
          style={styles.minWidth}
          filterToQuery={(searchText) => ({ warehouse_name: searchText })}
          perPage={100}
        >
          <SelectInput optionText="warehouse_name" sx={{ width: '50%' }} />
        </ReferenceInput>

        <FormDataConsumer>
          {({ formData }) => (
            <ArrayInput
              label="Extra Email CC's"
              source="extra_invitation_email_ccs"
            >
              <SimpleFormIterator>
                <TextInput label="CC Email" source="email" />
              </SimpleFormIterator>
            </ArrayInput>
          )}
        </FormDataConsumer>

        <Typography variant="h6" gutterBottom>
          Invitation Results
        </Typography>
        <GetInvitations />

        <Typography variant="h6" gutterBottom>
          Invitation History
        </Typography>
        <GetInvitationHistory />

        <Box display="flex" gap={2} mb={2}>
            <ReferenceManyField
                label="CSP Interest"
                reference="onpoint_extraction_software_invitation"
                target="master_customer_id"
                source="id"
                sort={{ field: "id", order: "DESC" }}
                formClassName={classes.inlineBlock}
              >
                <Labeled label="CSP Interest">
                  <FunctionField
                    source="accepted_center_store_participation"
                    render={record =>
                      record.accepted_center_store_participation === true ? "True" : "False"
                    }
                  />
                </Labeled>
              </ReferenceManyField>

              <BooleanInput
                resource="onpoint_master_customers"
                source="csp_participating"
                label="CSP Participating"
                formClassName={classes.inlineBlock}
              />
        </Box>

        <Typography variant="h7" gutterBottom>
          Active Signup (if applicable)
        </Typography>

        <Box display="flex" gap={2} mb={2} mt={2}>
          <FunctionField
                source="active_signup_date"
                label="Active Signup Date (if applicable)"
                formClassName={classes.inlineBlock}
                render={record => (typeof(record.wam_signup_date_added) === typeof(""))
                  ? <DateInput source = "wam_signup_date_added" label="active signup date" disabled name=""/>
                  : "No active signup"}
            />

          <FunctionField
                source="deleted_signup_date"
                label="Deleted Signup Date (if applicable)"
                formClassName={classes.inlineBlock}
                render={record => (typeof(record.deleted_signup_date) === typeof(""))
                  ? <DateInput source = "deleted_signup_date" disabled name=""/>
                  : "No deleted signup"}
            />
        </Box>
      </TabbedForm.Tab>

      {(typeof permissions === 'string' && permissions.endsWith('_admin')) &&
        <TabbedForm.Tab label="Admin">
          <AdminMasterStoreTab record={record} />
        </TabbedForm.Tab>
      }
    </TabbedForm>

  );
};


const StoreTitle = () => {
  const record = useRecordContext();

  return (
    <span>{record ? `${record.infobate_customer_name} - ${record.infobate_customer_state}` : ''}</span>
  );
};

let MasterCustomerEdit = () => {
  const permissions = usePermissions();
  const record = useRecordContext();

  return (
  <Edit title={<StoreTitle />} aside={<Aside record={record}/>}>
    <StoreForm permissions={permissions}/>
  </Edit>
)};


export default MasterCustomerEdit;
